import { render, staticRenderFns } from "./VisualizarEmpenhoSIAF.vue?vue&type=template&id=32b5fa08&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./VisualizarEmpenhoSIAF.vue?vue&type=style&index=0&id=32b5fa08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5fa08",
  null
  
)

export default component.exports